import { render, staticRenderFns } from "./XingBrands.vue?vue&type=template&id=5d3cb8fe"
import script from "./XingBrands.vue?vue&type=script&lang=ts"
export * from "./XingBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports